import { API_BASE_URL } from "./api-config";

interface TimeRange {
  start: string;
  end: string;
}

export interface Employee {
  id: string;
  displayName: string;
  description: string | null;
}

export interface ServiceEmployee {
  workerId: string;
  price: number;
}

export interface Category {
  id: string;
  name: string;
}

export interface Service {
  id: string;
  name: string;
  categoryId: string;
  length: string;
  workerIdList: ServiceEmployee[];
}

export interface OrganizationInfo {
  id: string;
  name: string;
  workTime: Record<string, TimeRange | null>;
  workerList: Employee[];
  serviceList: Service[];
  categoryList: Category[];
}

const BASE_URL = `${API_BASE_URL}/api/Organization`;

interface Options {
  signal?: AbortSignal;
}

export const Organization = {
  OrganizationInfo: async (
    organizationId: string,
    requestOptions: Options
  ): Promise<OrganizationInfo> => {
    const response = await fetch(
      `${BASE_URL}/OrganizationInfo/${organizationId}`,
      {
        method: "GET",
        ...requestOptions,
      }
    );

    if (response.status !== 200) {
      throw response.statusText;
    }

    return response.json();
  },
};
